import PropTypes from 'prop-types'
import React from 'react'
import { UserAvatar, SIZES } from 'components/Utils/Avatar'
import classNames from 'classnames'

export default function AvatarGroup({
  size,
  users,
  alignStart = false,
  maxAvatars = 3,
  borderColor = null,
}) {
  return (
    <section
      className={classNames(
        'avatar-group height-full flexbox flexbox-align-center',
        { 'flexbox-justify-end': !alignStart }
      )}
      style={!alignStart ? { width: 50, paddingRight: 5 } : {}}
    >
      {users.slice(0, maxAvatars).map((user, index) => {
        return (
          <div
            key={user.id}
            className={borderColor ? 'border-medium radius-round' : ''}
            style={{
              borderColor,
              marginLeft: index && borderColor ? -6 : -10,
            }}
          >
            <UserAvatar
              isWriting={user.isWriting}
              userId={user.id}
              size={size}
              noBorder={borderColor}
            />
          </div>
        )
      })}
    </section>
  )
}

AvatarGroup.propTypes = {
  size: PropTypes.oneOf(Object.keys(SIZES)),
  users: PropTypes.array.isRequired,
}

AvatarGroup.defaultProps = {
  size: 'xs',
}
